// 存储城市列表的数据
const movieScheduling = {
  namespaced: true,
  state: {
    // 电影信息movieInfo
    movieInfo: {}
  },
  mutations: {
    setMovieInfo (state, payload) {
      state.movieInfo = payload
    }
  },
  actions: {
    setMovieInfo (context, payload) {
      context.commit('setMovieInfo', payload)
    }
  }
}

export default movieScheduling



// WEBPACK FOOTER //
// ./src/store/buyTicket/movieScheduling.js